import { h } from "preact";

import classname from "../../../foundation/utils/classname";
import { copyContent } from "../../../foundation/utils/platform";

import styles from "./CopyContents.module.css";

interface Props {
    class?: string;
    lines: string[];
    onCopy?: () => void;
}

function CopyContents({ class: cssClass, lines, onCopy }: Props) {
    function handleCopy() {
        copyContent({
            content: lines.join("\n")
        });

        onCopy?.();
    }

    return (
        <button class={classname(styles.copyContents, cssClass)} onClick={handleCopy}>
            <strong>
                {lines.map((line, index) => <span class="caption-2" key={index}>{line}</span>)}
            </strong>
        </button>
    );
}

export default CopyContents;
